export class ValidationError extends Error {
  public reason?: string
  public references?: number[]
  public unassignedMemberIds?: number[]

  constructor({ message, reason, references, unassignedMemberIds }: { message?: string, reason?: string, references?: number[], unassignedMemberIds?: number[] }) {
    super(message || 'Um ou mais campos estão inválidos. Verifique os dados e tente novamente.')
    this.name = 'ValidationError'
    this.reason = reason
    this.references = references
    this.unassignedMemberIds = unassignedMemberIds
  }
}
